/* eslint-disable no-const-assign */
<template>
  <v-container fluid>
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">AREA</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="getData"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 500],
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-spacer></v-spacer>
          <v-btn
            small
            dark
            outlined
            color="primary"
            class="mr-2"
            title="Agregar"
            @click="addUpdate"
          >
            <v-icon>mdi-plus</v-icon>Nuevo
          </v-btn> -->
        </v-toolbar>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip
          small
          :color="item.estado ? 'success' : 'secondary'"
          dark
          v-text="item.estado ? 'ACTIVO' : 'INACTIVO'"
        >
        </v-chip>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-4" title="Editar" @click="addUpdate(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="inavilitar(item)" title="Inactivar">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <modal-add
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      @actualizar="getData"
    ></modal-add>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
import Paginado from "../../helpers/Paginado";
import Filtros from "../General/Filtros.vue";
import ModalAdd from "./ModalAdd.vue";

export default {
  components: {
    Filtros,
    ModalAdd,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Area",
  data() {
    return {
      coleccion: "area",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        {
          text: "AREA",
          filterable: true,
          align: "start",
          sortable: true,
          value: "nombre",
        },
        { text: "ESTADO", value: "estado" },
        { text: "ACCIONES", value: "action" },
      ],
      condicion: {},
    };
  },
  computed: {
    ...mapState(["logueado"]),
    autorizaCrear() {
      return this.logueado.cargo === "Administrador" ? true : false;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (element.value == "estado") {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    async getData() {
      try {
        const { itemsPerPage, page, sortBy, sortDesc } = this.options;
        this.itemsPerPage = itemsPerPage;
        this.ordenar = sortBy[0] || this.headers[0].value;
        this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
        this.criterios = await this.$refs.criterios.enviarCriterios();
        this.condicion = {};
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.criterios.forEach((element) => {
            if (element.campo && element.valor) {
              this.condicion = {
                campo: element.campo,
                operador: element.operador,
                valor: element.valor.toUpperCase().trim(),
              };
            }
          });
        }
        const paginado = new Paginado(
          db,
          this.coleccion,
          this.ordenar,
          itemsPerPage,
          page,
          this.condicion
        );
        const { registros, total } = await paginado.data();
        this.desserts = registros;
        this.totalItems = total;
        this.loading = false;
      } catch (error) {
        console.log("error", error);
        this.handleError(error);
      }
    },
    addUpdate(item = "") {
      if (!this.autorizaCrear) {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    inavilitar(item) {
      this.$swal({
        title: "",
        text: `Esta seguro de ${
          item.estado ? "inactivar" : "activar"
        } este registro?`,
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Confirmar!!",
      }).then((result) => {
        if (result.value) {
          if (!this.autorizaCrear) {
            this.handleError({
              message: "Usuario no autorizado",
            });
            return;
          }
          db.collection(this.coleccion)
            .doc(item.id)
            .update({ estado: !item.estado });
          this.getData();
          this.$swal({
            icon: "success",
            title: "Operación Exitosa",
            text: "",
          });
        }
      });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Area.scss" lang="scss" scope></style>
